import firebase from "firebase/compat/app"
import 'firebase/compat/firestore'

const config = {
    apiKey: "AIzaSyD6g1z3uXQSpWy3e7t6i-3cUSiE9zIRKf0",
    authDomain: "trouvez-votre-profil.firebaseapp.com",
    projectId: "trouvez-votre-profil",
    storageBucket: "trouvez-votre-profil.appspot.com",
    messagingSenderId: "461534944591",
    appId: "1:461534944591:web:57aacd54d1736ff34fb93a",
    measurementId: "G-GS2KZ8DM30"
  }
firebase.initializeApp(config)

export default firebase
